import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "regist" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-address-card" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.ikeposu.com/privacy-policy",
  target: "_blank"
}, [
  /*#__PURE__*/_createTextVNode("プライバシーポリシー "),
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-external-link-alt" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, null, {
          default: _withCtx(() => [
            _hoisted_2,
            _createTextVNode(" 新規登録")
          ]),
          _: 1
        }),
        _createVNode(_component_el_main, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              ref: "refFrmRegist",
              model: _ctx.frmRegist,
              rules: _ctx.rules,
              "label-width": "160px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "御社名（法人の場合）",
                  prop: "corporate_name"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      placeholder: "有限会社池田新聞店",
                      modelValue: _ctx.frmRegist.corporate_name,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.frmRegist.corporate_name) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "郵便番号",
                  prop: "postal_code"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      placeholder: "329-2136",
                      modelValue: _ctx.frmRegist.postal_code,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.frmRegist.postal_code) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "住所",
                  prop: "address"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      placeholder: "栃木県矢板市鹿島町1-35",
                      modelValue: _ctx.frmRegist.address,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.frmRegist.address) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "電話番号",
                  prop: "tel"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      placeholder: "0287-46-5353",
                      modelValue: _ctx.frmRegist.tel,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.frmRegist.tel) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "業種",
                  prop: "business"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_cascader, {
                      modelValue: _ctx.frmRegist.business,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.frmRegist.business) = $event)),
                      options: _ctx.businessOptions,
                      props: { expandTrigger: 'hover' }
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "ご担当者名",
                  prop: "person_charge"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      placeholder: "池田太郎",
                      modelValue: _ctx.frmRegist.person_charge,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.frmRegist.person_charge) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "メールアドレス",
                  prop: "mail_address"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      placeholder: "user@example.com",
                      modelValue: _ctx.frmRegist.mail_address,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.frmRegist.mail_address) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "パスワード",
                  prop: "password"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      placeholder: "8文字以上",
                      modelValue: _ctx.frmRegist.password,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.frmRegist.password) = $event)),
                      "show-password": "",
                      autocomplete: "off"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "パスワード（確認）",
                  prop: "checkPass"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      placeholder: "確認のため再入力してください。",
                      modelValue: _ctx.frmRegist.checkPass,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.frmRegist.checkPass) = $event)),
                      "show-password": "",
                      autocomplete: "off"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "個人情報の取扱い",
                  prop: "agree"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_checkbox, {
                      label: "同意する",
                      modelValue: _ctx.frmRegist.agree,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.frmRegist.agree) = $event))
                    }, null, 8, ["modelValue"]),
                    _createTextVNode(" （"),
                    _hoisted_3,
                    _createTextVNode("） ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    (_ctx.message)
                      ? (_openBlock(), _createBlock(_component_el_alert, {
                          key: 0,
                          title: _ctx.message,
                          type: "error"
                        }, null, 8, ["title"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _ctx.submitForm
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("登録")
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_el_button, { onClick: _ctx.resetForm }, {
                      default: _withCtx(() => [
                        _createTextVNode("Cancel")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}